import * as React from "react"
import {useState, useEffect} from 'react'

import PropTypes from "prop-types"
import { StaticImage } from "gatsby-plugin-image"
import { motion, useAnimation } from "framer-motion";
import '../components/navbar.scss'

const Navbar = ({ siteTitle }) => {
    const [scrollTop, setScrollTop] = useState(0);
  const [hasPulsed, setHasPulsed] = useState(false); // controls one-time pulse
  const controls = useAnimation();

  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY;
      setScrollTop(y);

      if (y > 35 && !hasPulsed) {
        setHasPulsed(true);
        controls.start({
          scale: [1, 1.1, 1],
          transition: { duration: 0.6 },
        });
      }

      if (y <= 35 && hasPulsed) {
        setHasPulsed(false); // allow re-pulse if scrolling back up and down
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasPulsed, controls]);

  // === Your original logic preserved ===
  let conditionalNavClasses, demoBtnColor;
  scrollTop < 35
    ? (demoBtnColor = "bg-secondary")
    : (demoBtnColor = "bg-primary");

  conditionalNavClasses =
    demoBtnColor === "bg-primary" ? "pt-1 bg-white" : "pt-1";
  return (
    <nav className={'navbar navbar-expand-lg sticky-top ' + conditionalNavClasses}>
      <div className="container d-flex justify-content-between">
        <a className="navbar-brand" href="/">
          <StaticImage
              className="dg-logo"
              src="../images/logo-blue.svg"
              width={285}
              height={52}
              quality={100}
              alt="Doctor Genius Logo"
              placeholder='none'
              loading="eager"
            />
        </a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-xl-center justify-content-xl-end" id="navbarSupportedContent">
          {/* USE THIS <UL> |  NOT OTHER ONE: ul.TEST(backup nav) */}
          <ul className="navbar-nav navbar-nav-scroll mb-2 mb-lg-0 pe-xl-4">

            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="/" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Patient Acquisition
              </a>
              <ul className="dropdown-menu single-col mt-3">
                <div className="row m-0 ps-3 my-xl-2">
                  <div className="col-sm-12 p-0">
                  <div className="content-area dropdown-item ms-0 px-0 py-2 d-flex">
                      <div className="right-blue-carrot">
                        <StaticImage
                          src="../images/right-blue-carrot.png"
                          width={8}
                          height={10}
                          quality={100}
                          alt="arrow"
                          placeholder='none'
                          style={{width: "max-content"}}
                          loading="eager"
                        />
                      </div>
                      <div className="d-flex col-sm-11 col-md-11 col-lg-11 flex-column ps-3">
                        <a className="link-header pt-1 col-sm-11" href="/marketing-solutions">Solutions Overview</a>
                        <a className="link-desc pb-1 col-sm-11 col-md-11 col-lg-12" href="/marketing-solutions"><p>Streamline practice needs with our all-in-one platform. Increase patient interaction, automate marketing, and boost revenue.</p></a>
                      </div>
                    </div>
                    <div className="content-area dropdown-item ms-0 px-0 py-2 d-flex">
                      <div className="right-blue-carrot">
                        <StaticImage
                          src="../images/right-blue-carrot.png"
                          width={8}
                          height={10}
                          quality={100}
                          alt="arrow"
                          placeholder='none'
                          style={{width: "max-content"}}
                          loading="eager"
                        />
                      </div>
                      <div className="d-flex col-sm-11 col-md-11 col-lg-11 flex-column ps-3">
                        <a className="link-header pt-1 col-sm-11" href="/dg-framework-websites">DG Framework</a>
                        <a className="link-desc pb-1 col-sm-11 col-md-11 col-lg-12" href="/dg-framework-websites"><p>Boost your website's ranking with our solid DG Framework. SEO, structured data, and high-quality content for top visibility.</p></a>
                      </div>
                    </div>
                    {/* <div className="content-area dropdown-item ms-0 px-0 py-2 d-flex">
                      <div className="right-blue-carrot">
                        <StaticImage
                          src="../images/right-blue-carrot.png"
                          width={8}
                          height={10}
                          quality={100}
                          alt="arrow"
                          placeholder='none'
                          style={{width: "max-content"}}
                        />
                      </div>
                      <div className="d-flex col-sm-11 col-md-11 col-lg-11 flex-column ps-3">
                        <a className="link-header pt-1 col-sm-11" href="/px-patient-experience">PX Patient Experience</a>
                        <a className="link-desc pb-1 col-sm-11 col-md-11 col-lg-12" href="/px-patient-experience"><p>Automate patient communication for delighted, engaged patients. Share positive experiences and boost satisfaction.</p></a>
                      </div>
                    </div> */}
                    <div className="content-area dropdown-item ms-0 px-0 py-2 d-flex">
                      <div className="right-blue-carrot">
                        <StaticImage
                          src="../images/right-blue-carrot.png"
                          width={8}
                          height={10}
                          quality={100}
                          alt="arrow"
                          placeholder='none'
                          style={{width: "max-content"}}
                          loading="eager"
                        />
                      </div>
                      <div className="d-flex col-sm-11 col-md-11 col-lg-11 flex-column ps-3">
                        <a className="link-header pt-1 col-sm-11" href="/content-ignition-package">Content Ignition Package</a>
                        <a className="link-desc pb-1 col-sm-11 col-md-11 col-lg-12" href="/content-ignition-package"><p>Become a local content king. Boost online presence and showcase expertise with targeted blogs.</p></a>
                      </div>
                    </div>
                  </div>
                </div>
              </ul>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" aria-current="page" href="/px-patient-experience" role="button" data-bs-toggle="dropdown" aria-expanded="false" >Patient Experience (PX)</a>
              <ul className="dropdown-menu single-col mt-3">
                <div className="row m-0 ps-3 my-xl-2">
                  <div className="content-area dropdown-item ms-0 px-0 py-2 d-flex">
                      <div className="right-blue-carrot">
                        <StaticImage
                          src="../images/right-blue-carrot.png"
                          width={8}
                          height={10}
                          quality={100}
                          alt="arrow"
                          placeholder='none'
                          style={{width: "max-content"}}
                          loading="eager"
                        />
                      </div>
                      <div className="d-flex col-sm-11 col-md-11 col-lg-11 flex-column ps-3">
                        <a className="link-header pt-1 col-sm-11" href="/px-patient-experience">PX Overview</a>
                        <a className="link-desc pb-1 col-sm-11 col-md-11 col-lg-12" href="/px-patient-experience"><p>Enable tools for your practice to enhance healthcare experiences to gain and retain new patients.</p></a>
                      </div>
                    </div>
                    <div className="content-area dropdown-item ms-0 px-0 py-2 d-flex">
                      <div className="right-blue-carrot">
                        <StaticImage
                          src="../images/right-blue-carrot.png"
                          width={8}
                          height={10}
                          quality={100}
                          alt="arrow"
                          placeholder='none'
                          style={{width: "max-content"}}
                          loading="eager"
                        />
                      </div>
                      <div className="d-flex col-sm-11 col-md-11 col-lg-11 flex-column ps-3">
                        <a className="link-header pt-1 col-sm-11" href="/px-patient-experience/reviews">PX Reviews</a>
                        <a className="link-desc pb-1 col-sm-11 col-md-11 col-lg-12" href="/px-patient-experience/reviews"><p>Send post appointment follow ups to gather patient feedback, positioning your practice as proactive and convenient for quality care.</p></a>
                      </div>
                    </div>
                    <div className="content-area dropdown-item ms-0 px-0 py-2 d-flex">
                      <div className="right-blue-carrot">
                        <StaticImage
                          src="../images/right-blue-carrot.png"
                          width={8}
                          height={10}
                          quality={100}
                          alt="arrow"
                          placeholder='none'
                          style={{width: "max-content"}}
                          loading="eager"
                        />
                      </div>
                      <div className="d-flex col-sm-11 col-md-11 col-lg-11 flex-column ps-3">
                        <a className="link-header pt-1 col-sm-11" href="/px-patient-experience/engagement">PX Engagement</a>
                        <a className="link-desc pb-1 col-sm-11 col-md-11 col-lg-12" href="/px-patient-experience/engagement"><p>Empower and engage patients with automated appointment reminders and recall emails and SMS for a personal touch.</p></a>
                      </div>
                    </div>
                    <div className="content-area dropdown-item ms-0 px-0 py-2 d-flex">
                      <div className="right-blue-carrot">
                        <StaticImage
                          src="../images/right-blue-carrot.png"
                          width={8}
                          height={10}
                          quality={100}
                          alt="arrow"
                          placeholder='none'
                          style={{width: "max-content"}}
                          loading="eager"
                        />
                      </div>
                      <div className="d-flex col-sm-11 col-md-11 col-lg-11 flex-column ps-3">
                        <a className="link-header pt-1 col-sm-11" href="/px-patient-experience/scheduler">PX Scheduler</a>
                        <a className="link-desc pb-1 col-sm-11 col-md-11 col-lg-12" href="/px-patient-experience/scheduler"><p>Enable patients to schedule appointments integrated with your PMS calendar while prioritizing and filling open time slots.</p></a>
                      </div>
                    </div>
                </div>
              </ul>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="/" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Practice Analytics
              </a>
              <ul className="dropdown-menu single-col mt-3">
                <div className="row m-0 ps-3 my-xl-2">
                  <div className="content-area dropdown-item ms-0 px-0 py-2 d-flex">
                      <div className="right-blue-carrot">
                        <StaticImage
                          src="../images/right-blue-carrot.png"
                          width={8}
                          height={10}
                          quality={100}
                          alt="arrow"
                          placeholder='none'
                          style={{width: "max-content"}}
                          loading="eager"
                        />
                      </div>
                      <div className="d-flex col-sm-11 col-md-11 col-lg-11 flex-column ps-3">
                        <a className="link-header pt-1 col-sm-11" href="/caller-iq-ai-call-tracking">Caller IQ&trade;</a>
                        <a className="link-desc pb-1 col-sm-11 col-md-11 col-lg-12" href="/caller-iq-ai-call-tracking"><p>AI powered solution to improve front office communication and patient satisfaction with scored calls and training insights.</p></a>
                      </div>
                    </div>
                    <div className="content-area dropdown-item ms-0 px-0 py-2 d-flex">
                      <div className="right-blue-carrot">
                        <StaticImage
                          src="../images/right-blue-carrot.png"
                          width={8}
                          height={10}
                          quality={100}
                          alt="arrow"
                          placeholder='none'
                          style={{width: "max-content"}}
                          loading="eager"
                        />
                      </div>
                      <div className="d-flex col-sm-11 col-md-11 col-lg-11 flex-column ps-3">
                        <a className="link-header pt-1 col-sm-11" href="/portal-dashboard">Portal Dashboard</a>
                        <a className="link-desc pb-1 col-sm-11 col-md-11 col-lg-12" href="/portal-dashboard"><p>Simplify practice management with our all-in-one Dashboard. Track analytics, inquiries, reputation, and ranking for practice growth.</p></a>
                      </div>
                    </div>
                    <div className="content-area dropdown-item ms-0 px-0 py-2 d-flex">
                      <div className="right-blue-carrot">
                        <StaticImage
                          src="../images/right-blue-carrot.png"
                          width={8}
                          height={10}
                          quality={100}
                          alt="arrow"
                          placeholder='none'
                          style={{width: "max-content"}}
                          loading="eager"
                        />
                      </div>
                      <div className="d-flex col-sm-11 col-md-11 col-lg-11 flex-column ps-3">
                        <a className="link-header pt-1 col-sm-11" href="/practice-analytics-iq">DG IQ</a>
                        <a className="link-desc pb-1 col-sm-11 col-md-11 col-lg-12" href="/practice-analytics-iq"><p>Maximize your practice's potential with our Business Intelligence tools. Gain unparalleled insights and make informed decisions for smarter practice success</p></a>
                      </div>
                    </div>
                </div>
              </ul>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle " href="/" role="button" data-bs-toggle="dropdown" aria-expanded="false" onClick={() => console.log('toggle')}>
                Resources
              </a>
              <ul className="dropdown-menu single-col mt-3">
                <div className="row m-0 ps-3 my-xl-2">
                  <div className="col-sm-12 p-0">
                    
                  <div className="content-area dropdown-item px-0 py-2 d-flex">
                      <div>
                        <StaticImage
                          src="../images/right-blue-carrot.png"
                          width={8}
                          height={10}
                          quality={100}
                          alt="arrow"
                          placeholder='none'
                          style={{width: "max-content"}}
                          loading="eager"
                        />
                      </div>
                      <div className="d-flex col-sm-11 col-md-11 col-lg-10 flex-column ps-3">
                        <a className="link-header pt-1 col-sm-11" href="/company">About</a>
                        <a className="link-desc pb-1 col-sm-11 col-md-11 col-lg-12" href="/company"><p>Offering high-end marketing services to health professionals.</p></a>
                      </div>
                    </div>
                    <div className="content-area dropdown-item px-0 py-2 d-flex">
                      <div>
                        <StaticImage
                          src="../images/right-blue-carrot.png"
                          width={8}
                          height={10}
                          quality={100}
                          alt="arrow"
                          placeholder='none'
                          style={{width: "max-content"}}
                          loading="eager"
                        />
                      </div>
                      <div className="d-flex col-sm-11 col-md-11 col-lg-10 flex-column ps-3">
                        <a className="link-header pt-1 col-sm-11" href="/contact">Contact</a>
                        <a className="link-desc pb-1 col-sm-11 col-md-11 col-lg-12" href="/contact"><p>Have a question? Send us a message.</p></a>
                      </div>
                    </div>
                    <div className="content-area dropdown-item px-0 py-2 d-flex">
                      <div>
                        <StaticImage
                          src="../images/right-blue-carrot.png"
                          width={8}
                          height={10}
                          quality={100}
                          alt="arrow"
                          placeholder='none'
                          style={{width: "max-content"}}
                          loading="eager"
                        />
                      </div>
                      <div className="d-flex col-sm-11 col-md-11 col-lg-10 flex-column ps-3">
                        <a className="link-header pt-1" href="/resources">Resource Hub</a>
                        <a className="link-desc pb-1 col-sm-11 col-md-11 col-lg-12" href="/resources"><p>View comprehensive content covering dental & healthcare marketing, webinars, podcasts, and customer success stories.</p></a>
                      </div>
                    </div>
                    <div className="content-area dropdown-item px-0 py-2 d-flex">
                      <div>
                        <StaticImage
                          src="../images/right-blue-carrot.png"
                          width={8}
                          height={10}
                          quality={100}
                          alt="arrow"
                          placeholder='none'
                          style={{width: "max-content"}}
                          loading="eager"
                        />
                      </div>
                      <div className="d-flex col-sm-11 col-md-11 col-lg-10 flex-column ps-3">
                        <a className="link-header pt-1" href="/resources/case-studies">Case Studies</a>
                        <a className="link-desc pb-1 col-sm-11 col-md-11 col-lg-12" href="/resources/case-studies"><p>Explore customer testimonials and case studies showcasing how Doctor Genius directly boosts practice growth.</p></a>
                      </div>
                    </div>
                    <div className="content-area dropdown-item px-0 py-2 d-flex">
                        <div>
                          <StaticImage
                            src="../images/right-blue-carrot.png"
                            width={8}
                            height={10}
                            quality={100}
                            alt="arrow"
                            placeholder='none'
                            style={{width: "max-content"}}
                            loading="eager"
                          />
                        </div>
                        <div className="d-flex col-sm-11 col-md-11 col-lg-10 flex-column ps-3">
                          <a className="link-header pt-1 col-sm-11" href="/blog">Blog</a>
                          <a className="link-desc pb-1 col-sm-11 col-md-11 col-lg-12" href="/blog"><p>Education on all things digital marketing and practice management.</p></a>
                        </div>
                      </div>                      
                     </div>
                </div>
              </ul>
            </li>
          </ul>
        </div>
            <a className="demo-button-holder" href="/demo">
      <motion.button
      
        type="submit"
        animate={controls}
        className={`btn demo-button text-white bg-primary`}
        whileHover={{
      y: -3,
      boxShadow: "0px 8px 16px rgba(0, 250, 183, 0.4)", // pink shadow
          backgroundImage: "linear-gradient(90deg, #00CB94 0%, #108FFF 100%)",
    }}
      >
        Request Demo
        <StaticImage
          loading="eager"
          className="white-right-arrow"
          layout="fixed"
          src="../images/right-arrow.png"
          width={15}
          quality={100}
          alt="Right arrow"
        />
      </motion.button>
    </a>
      </div>
</nav>
  )
}

Navbar.propTypes = {
  siteTitle: PropTypes.string,
}

Navbar.defaultProps = {
  siteTitle: `Doctorgenius.com`,
}

export default Navbar
